<template>
  <b-container id="app">
    <router-view/>
  </b-container>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import './styles/master.scss'

Vue.use(BootstrapVue)

export default {
  components: {
    //TopBar
  }
}
</script>

<style lang="scss"></style>
